export default __webpack_public_path__ + "static/media/personality-small-share.bfd4d266.svg";